import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-overlay-header',
  templateUrl: './map-overlay-header.component.html',
  styleUrls: ['./map-overlay-header.component.scss']
})
export class MapOverlayHeaderComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
